module.exports = __webpack_public_path__ + "img/icon_gift_card.0caa9a1c.svg";